import React, { useEffect } from "react";
import SMNavBar from "../Comps/Station Map/SMNavBar";

const StationMap = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <div
      className=" text-center  "
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #cf8977 0%, #fbede0 45%, #fbede0 80%, #F0F3FA 100%)",
      }}
    >
      <SMNavBar />
    </div>
  );
};
export default StationMap;
